export enum ButtonSizes {
    Large = "-large",
    Medium = "-medium",
    Small = "-small",
    XSmall = "-xsmall",
}
